import * as React from 'react'

import { StyledLinkButton } from './LinkButton.glamorous'

export type Props = {
    url?: string;
}

export const LinkButton: React.SFC<Props> = ({children}) => {
    return (
        <StyledLinkButton to="/login">{children}</StyledLinkButton>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/components/LinkButton/LinkButton.tsx